import { useMutation, useQueryClient } from "@tanstack/react-query";
import { trainerFilesApi } from "api/trainers/trainerFilesApi";
import { QUERIES_KEYS } from "queries";

export const useUploadTrainerFile = (trainerId: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ file, note }: { file: File; note?: string }) =>
      trainerFilesApi.uploadFile(trainerId, file, note),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERIES_KEYS.TRAINER_FILES(trainerId) });
    },
  });
};
